/**
 * All the utility functions for firestore go here
 */

export default {
  /**
   * Takes in docs of the collection, iterates over it and returns a formatted array.
   * @param {*} docs
   */
  getCollectionData(docs) {
    const items = [];

    if (docs.empty) {
      return items;
    }

    docs.forEach(doc => {
      const item = doc.data();
      item.docId = doc.id;
      items.push(item);
    });

    return items;
  },

  /**
   * This methods loops through all the collection items.
   * It then fetches all the reference data of each items
   * and replaces reference object with the data.
   * Lets say we have cart collection, and every doc in it
   * has a reference to product. This method goes through all
   * the docs in the cart collection, fetches product data from
   * the reference, and replaces it.
   */
  getAllReferenceData(docs, references) {
    return new Promise((resolve, reject) => {
      const items = this.getCollectionData(docs);

      this.getDataFromReferences(items, references)
        .then(() => resolve(items))
        .catch(err => reject(err));
    });
  },

  getDataFromReferences(items, references) {
    const promises = [];
    items.forEach(item =>
      promises.push(this.getReferenceData(item, references))
    );
    return Promise.all(promises);
  },

  getReferenceData(item, references) {
    const promises = [];
    references.forEach(reference =>
      promises.push(this.getData(item, reference))
    );
    return Promise.all(promises);
  },

  getData(item, reference) {
    return new Promise(resolve => {
      if (!item[reference]) {
        item[reference] = {};
        resolve(item);
      } else {
        item[reference].get().then(doc => {
          item[reference] = this.getDocData(doc);
          item[reference].docId = doc.id;
          resolve(item);
        });
      }
    });
  },

  getDocData(doc) {
    if (doc.exists) {
      return {
        docId: doc.id,
        ...doc.data()
      };
    }

    return null;
  }
};



// WEBPACK FOOTER //
// ./src/lib/Firestore.js